import { Link } from 'react-router-dom'
import { navigation, site } from '../data/site'

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-container footer-grid">
        <div>
          <img className="footer-logo" src="/assets/em-whell-logo.png" alt="Em Whell Motorsport" width="1200" height="231" loading="lazy" />
          <p>Driver of the #{site.number} {site.className}<br />{site.location}</p>
        </div>
        <nav className="footer-nav" aria-label="Footer navigation">
          {navigation.map((item) => <Link key={item.to} to={item.to}>{item.label}</Link>)}
          <a href={site.facebook} target="_blank" rel="noreferrer">Facebook</a>
        </nav>
        <div className="footer-contact">
          {/* <a href={`tel:${site.phoneHref}`}>{site.phoneDisplay}</a> */}
          <a href={`mailto:${site.email}`}>{site.email}</a>
          <span>© {new Date().getFullYear()} {site.team}</span>
        </div>
      </div>
    </footer>
  )
}
